<template>
  <div id="lumio">
    <NavigationBar />

    <Breadcrumb :productName="Breadcrumb.productName" />

    <MainBannerProduct
      :productName="banner.productName"
      :tagline="banner.tagline"
      :features="banner.features"
      :directLink="banner.link"
      :img="banner.img"
      :posTop="banner.posTop"
      :posBottom="banner.posBottom"
      :imageScale="banner.imageScale"
      :price="banner.price"
    />

    <DownloadBanner />

    <div class="uk-section uk-background-muted uk-padding-remove-bottom">
      <div class="uk-container uk-container-expand uk-padding-remove">
        <div
          class="uk-flex uk-flex-center uk-flex-stretch uk-cover-container"
          uk-grid
        >
          <div class="uk-width-1-1">
            <img src="../assets/Asset 1@2x.png" alt="" width="100%" uk-img />
          </div>
        </div>
      </div>
    </div>

    <!-- 	<div class="uk-section">
			<div class="uk-container uk-container-expand">
				<div class="uk-flex uk-flex-center" uk-grid>
					<div class="uk-width-1-1">
						<h3 class="uk-text-uppercase uk-text-center">music synchronization</h3>
						
						<div class="uk-cover-container uk-height-medium">
							<iframe src="https://www.youtube-nocookie.com/embed/c2pz2mlSfXA?autoplay=1&controls=0&showinfo=0&rel=0&loop=1&modestbranding=1&wmode=transparent&enablejsapi=1" 
									width="1920" 
									height="1080" 
									frameborder="0" 
									allowfullscreen="" 
									uk-cover 
									class="uk-cover"></iframe>
						</div>
					</div>
				</div>
			</div>
		</div> -->

    <ProductSpesification
      :productName="banner.productName"
      :description="productSpesification.description"
      :features="productSpesification.features"
      :link="productSpesification.link"
      :img="productSpesification.img"
      :imgScale="productSpesification.imgScale"
      :imgPositionX="productSpesification.imgPositionX"
      :imgPositionY="productSpesification.imgPositionY"
      :spesification="productSpesification.spesification"
    />

    <div class="uk-section uk-padding-remove">
      <hr />
    </div>

    <!-- <div class="uk-section">
			<div class="uk-container">
				<div class="uk-flex uk-flex-middle uk-margin-remove-left" uk-grid>
					<router-link to="" class="uk-button uk-button-primary uk-margin-auto" style="border-radius: 10px;x">
						<h3 class="uk-text-uppercase" style="color: rgb(255, 255, 255); padding: 1vw;">buy now</h3>
					</router-link>
				</div>
			</div>
		</div> -->

    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Footer from "@/components/Footer.vue";
import MainBannerProduct from "@/components/MainBannerProduct.vue";
import DownloadBanner from "@/components/DownloadBanner.vue";
import ProductSpesification from "@/components/ProductSpesification.vue";
import NavbarMobileComponent from "@/components/NavbarMobileComponent.vue"

export default {
  name: "lumio",
  components: {
    NavigationBar,
    Breadcrumb,
    MainBannerProduct,
    DownloadBanner,
    ProductSpesification,
	Footer,
	NavbarMobileComponent,
  },
  data() {
    return {
      Breadcrumb: {
        productName: "lumio",
      },
      banner: {
        productName: "lumio",
        tagline: "your smart home lighting",
        features: [
          "lighting",
          "remote connectivity",
          "app control",
          "vibrant colors",
        ],
        link: "https://youtu.be/X-p20C2mugs",
        img: require('../assets/lumio-banner-1.png'),
        posTop: "-150px",
        posBottom: "-330px",
        imageScale: "scale(1.2)",
        price: '',
      },
      productSpesification: {
        description: "Adjust to any color to suit your mood or occasion.",
        features: [
          "Warm and Cool Lightning.",
          "Multiple color option.",
          "Contorl Switch from Smart Devices.",
          "Adjustable Brightness (Dim).",
          "Music Synchronization.",
          "Auto timer.",
          "App Connectivity on iOS & Android Devices.",
        ],
        price: "Rp. 123.500,00 include gst",
        link: "",
        img: require("../assets/roommm.png"),
        imgScale: "scale(.7)",
        imgTransformX: "right",
        imgPositionY: "0",
        spesification: [
          {
            title: "Model",
            subtitle: "Lumio",
          },
          {
            title: "Dimension",
            subtitle: "60 x 60 x 105 mm",
          },
          {
            title: "Wireless Protocol",
            subtitle: "2.4GHz WiFi router",
          },
          {
            title: "Color",
            subtitle: "All Color",
          },
          {
            title: "App Support",
            subtitle:
              "Roomi App (Apple iOS 10.3 or later, Android 5.0 or later).",
          },

          {
            title: "Masa Pakai",
            subtitle: "50.000 jam",
          },
          {
            title: "Power Usage",
            subtitle: "9W",
          },
        ],
      },
    };
  },
  computed: {
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  mounted() {
  }
};
</script>

<style>
</style>